import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { SentryService } from '../../services/sentry.service';
import * as Sentry from '@sentry/angular-ivy';

@Injectable()
export class SentryInterceptor implements HttpInterceptor {

  constructor(private sentryService: SentryService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime = Date.now();
    
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const duration = Date.now() - startTime;
          this.sentryService.profileApiCall(
            req.url, 
            req.method, 
            duration, 
            event.status
          );
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const duration = Date.now() - startTime;
        
        this.sentryService.profileApiCall(
          req.url, 
          req.method, 
          duration, 
          error.status
        );

        Sentry.withScope((scope) => {
          scope.setTag('api_error', 'true');
          scope.setContext('http_request', {
            url: req.url,
            method: req.method,
            status: error.status,
            duration: duration
          });
          
          if (error.status >= 500) {
            scope.setLevel('error');
            this.sentryService.captureException(error);
          } else if (error.status >= 400) {
            scope.setLevel('warning');
            this.sentryService.captureMessage(
              `HTTP ${error.status}: ${req.method} ${req.url}`,
              'warning'
            );
          }
        });

        throw error;
      })
    );
  }
}